import React from 'react';
import { Typography, Stack, Button } from '@mui/material';

interface MessageProps {
  message: any;
}

const formatText = (text: string): string => {
  if (!text) return '';
  let formatted = text;
 
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>'); 
  formatted = formatted.replace(/_(.*?)_/g, '<i>$1</i>'); 

  return formatted;
};


const MessageInterventionReply: React.FC<MessageProps> = ({ message }) => {
  try {
    const content = message?.content || {};
    const headerText = content?.header?.text || '';
    const bodyText = content?.body?.text || 'No message content available';
    const footerText = content?.footer?.text || '';
    const buttons = content?.buttons || [];

    return (
      <Stack spacing={1}>
        {/* Header */}
        {headerText && (
          <Typography variant="subtitle2" fontWeight="bold" dangerouslySetInnerHTML={{ __html: formatText(headerText) }}
>
            {/* {headerText} */}
          </Typography>
        )}

        {/* Body */}
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
>
          {/* {bodyText} */}
        </Typography>

        {/* Buttons */}
        {buttons.length > 0 && (
          <Stack spacing={1} mt={1}>
            {buttons.map((btn: any, idx: number) => (
              <Button
                key={idx}
                size="small"
                variant="outlined"
                fullWidth
                sx={{ textTransform: 'none' }}
              >
                {btn.label}
              </Button>
            ))}
          </Stack>
        )}

        {/* Footer */}
        {footerText && (
          <Typography variant="caption" color="text.secondary" dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
>
            {/* {footerText} */}
          </Typography>
        )}
      </Stack>
    );
  } catch (error) {
    return <div>Error displaying intervention reply</div>;
  }
};

export default MessageInterventionReply;
